import { NavLink } from "react-router-dom";
import { Home, BookOpen, Calendar, ShoppingCart, MoreHorizontal, Camera } from "lucide-react";

const tabs = [
  { to: "/", label: "Accueil", icon: Home, testid: "nav-tab-accueil" },
  { to: "/recipes", label: "Recettes", icon: BookOpen, testid: "nav-tab-recettes" },
  { to: "/scan", label: "Scanner", icon: Camera, testid: "nav-tab-scan", accent: true },
  { to: "/week", label: "Semaine", icon: Calendar, testid: "nav-tab-semaine" },
  { to: "/shopping", label: "Courses", icon: ShoppingCart, testid: "nav-tab-courses" },
  { to: "/more", label: "Plus", icon: MoreHorizontal, testid: "nav-tab-plus" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-black/5 backdrop-blur-md"
      style={{ background: "rgba(255,255,255,0.92)" }}
      data-testid="bottom-nav"
    >
      <div className="mx-auto flex max-w-2xl items-stretch justify-around px-1 pb-[env(safe-area-inset-bottom)] pt-2">
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === "/"}
              data-testid={t.testid}
              className="at-press flex flex-1 flex-col items-center gap-1 py-1"
            >
              {({ isActive }) => {
                const color = isActive || t.accent ? "var(--at-brand)" : "var(--at-muted)";
                return (
                  <>
                    <Icon size={22} strokeWidth={isActive ? 2.4 : 1.9} color={color} />
                    <span className="text-[10px] font-medium" style={{ color }}>
                      {t.label}
                    </span>
                  </>
                );
              }}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
